<template>
  <b-collapse class="navbar-actions" is-nav>
    <b-navbar-nav>
      <b-nav-item-dropdown class="main-nav-item" right>
        <template slot="button-content">
          <span class="text-white" v-if="currentUser">
            {{ currentUser.display_name ? currentUser.display_name : currentUser.username }}
          </span>
        </template>
        <b-dropdown-item :active="this.$route.name == 'profile'" to="/profile">{{ $t('Profile') }}</b-dropdown-item>
        <b-dropdown-item v-on:click="logout()" href="#">{{ $t('Sign Out') }}</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-collapse>
</template>

<script>
  import auth from '../../services/auth.service';
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "NavbarActions",
    methods: {
      logout() {
        auth.logout();
      }
    },
    computed: {
      ...mapState({
        currentUser: state => state.currentUser,
      })
    }
  }
</script>

<style lang="scss">
  .navbar-actions {
    flex: 0;

    .navbar-nav {
      .main-nav-item {
        .nav-link.dropdown-toggle {
          &:active {
            outline: 0;
          }

          &:focus {
            outline: 0;
          }
        }
      }
    }
  }
</style>
